import React, {FC, Fragment, useState} from "react";
import CommonLayout from "../CommonLayout";
import {Tab} from "@headlessui/react";
import VisaPage6Item from "./VisaPage6Item";
import {useAppSelector} from '../../../utils/customHooks';
export interface PageAddListing1Props {
}

const VisaPage6: FC<PageAddListing1Props> = () => {
  const {numberOfApplicants, applicantsData, uid} = useAppSelector(state => state.visa_page)
  let names = [...new Array(+numberOfApplicants)].map((el,index) => {
    return applicantsData[index]?.fullName ? applicantsData[index]?.fullName : `Заявитель ${index + 1}`
  })
  const prefix = uid?.split('-')[0]
  const isPH = prefix === 'PH' || prefix === 'VH';
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [errorField, setErrorField] = useState<string | null>(null)

  const setSelectedAndErrorField = (index: number, fieldName:string) => {
    setSelectedIndex(index)
    setErrorField(fieldName)
  }

  const handleTabChange = (index: number) => {
    setSelectedIndex(index)
    setErrorField(null)
  }

  return (
    <CommonLayout
      index="05"
    >
      <>
        <div>
          <Tab.Group selectedIndex={selectedIndex} onChange={handleTabChange}>
            <Tab.List className="flex space-x-4 overflow-x-auto">
              {names.map((item,i) => (
                <Tab key={item+i} as={Fragment}>
                  {({selected}) => (
                    <button
                      className={`flex justify-center self-center px-4 py-2 text-sm rounded-full border focus:outline-none cursor-pointer transition-all ${
                        selected
                          ? "border-primary-600 bg-primary-50 text-primary-700"
                          : "border-neutral-300 dark:border-neutral-700"
                      } `}
                    >
                      {item}
                    </button>
                  )}
                </Tab>
              ))}
            </Tab.List>
            <Tab.Panels>
              <Tab.Panels>
                {[...new Array(+numberOfApplicants)].map((el,index) => {
                  return (
                      <Tab.Panel className="" key={index}>
                        <VisaPage6Item index={index} isPH={isPH} setSelectedAndErrorField={setSelectedAndErrorField} errorField={errorField}/>
                      </Tab.Panel>
                  )
                })}
              </Tab.Panels>
            </Tab.Panels>
          </Tab.Group>
        </div>
      </>
    </CommonLayout>
  )
    ;
};

export default VisaPage6;
